import PropTypes from 'prop-types'
import {Box, Button, Text} from '@chakra-ui/react'
import {RepeatIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'

const TextLoading = ({size}) => (
  <Box ml="5px" my="sm">
    <Box
      background="linear-gradient(to right, transparent, #EBE9E7)"
      boxShadow="#EBE9E7 5px 0px 10px"
      height="16px"
      width={size === 'lg' ? '160px' : '60px'}
    />
  </Box>
)

TextLoading.defaultProps = {
  size: null,
}

TextLoading.propTypes = {
  size: PropTypes.string,
}

const PdfFallback = ({onRefresh}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Box display="flex" justifyContent="center" height="100%">
      <Box
        alignSelf="center"
        height="352px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        m="sm"
      >
        <Box
          height="216px"
          borderTopLeftRadius="4px"
          borderTopRightRadius="4px"
          borderTop="1px solid"
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="mld.neutral.600"
        >
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            p="sm"
            width="100%"
            borderBottom="1px solid"
            borderColor="mld.neutral.600"
          >
            <Box>
              <Text textStyle="caption" color="mld.neutral.700">
                {t('paymentWizard.payableContentPanel.pdfFallback.invoiceNo')}
              </Text>
              <TextLoading />
            </Box>
            <Box display="flex" flexDirection="row">
              <Box mr="sm">
                <Text textStyle="caption" color="mld.neutral.700">
                  {t('paymentWizard.payableContentPanel.pdfFallback.issued')}
                </Text>
                <TextLoading />
              </Box>
              <Box>
                <Text textStyle="caption" color="mld.neutral.700">
                  {t('paymentWizard.payableContentPanel.pdfFallback.due')}
                </Text>
                <TextLoading />
              </Box>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            p="sm"
            justifyContent="space-between"
          >
            <Box>
              <Text textStyle="caption" color="mld.neutral.700">
                {t('paymentWizard.payableContentPanel.pdfFallback.from')}
              </Text>
              <TextLoading />
              <TextLoading size="lg" />
            </Box>
            <Box>
              <Text textStyle="caption" color="mld.neutral.700">
                {t('paymentWizard.payableContentPanel.pdfFallback.to')}
              </Text>
              <TextLoading />
              <TextLoading size="lg" />
            </Box>
          </Box>
        </Box>
        <Box height="112px" p="sm">
          <Text textStyle="headline3" mb="sm">
            {t('paymentWizard.payableContentPanel.pdfFallback.noInvoiceTitle')}
          </Text>
          <Text textStyle="headline5" mb="sm" color="mld.neutral.700">
            {t(
              'paymentWizard.payableContentPanel.pdfFallback.noInvoiceDescription',
            )}
          </Text>
          <Box mb="sm">
            <Button
              mr="sm"
              variant="secondary"
              rightIcon={<RepeatIcon />}
              onClick={onRefresh}
            >
              {t('paymentWizard.payableContentPanel.pdfFallback.refreshButton')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

PdfFallback.defaultProps = {
  onRefresh: null,
}

PdfFallback.propTypes = {
  onRefresh: PropTypes.func,
}

export default PdfFallback
